import { createSlice } from '@reduxjs/toolkit';
import getInitialState from 'tradera-state/views/cart/initial-state';

const cartSlice = createSlice({
    name: 'cart',
    initialState: getInitialState(),
    reducers: {
        setFetching: (state, { payload }) => {
            state.isFetching = payload;
        },
        setCartData: (state, { payload }) => {
            state.isFetching = false;
            state.merchantPreOrders = payload.merchantPreOrders;
        }
    }
});

export const { setFetching, setCartData } = cartSlice.actions;

export default cartSlice.reducer;
